import React from 'react';
import styled from '@emotion/styled';

const DI_LOGO_ANIMATION =
  'https://di-static-assets.azureedge.net/images/logo-animation-dark-transparent.gif';

const AnimationWrapper = styled('div')`
  text-align: center;
`;
const Image = styled('img')`
  height: 200px;
`;

export default function DiLoading() {
  return (
    <AnimationWrapper>
      <Image src={DI_LOGO_ANIMATION} alt="Di logo animation" />
    </AnimationWrapper>
  );
}
